import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePlayerProfile } from '../../../features/playerProfile/playerProfileSlice';
import { CARD, CardTitle, EditButton, SECONDARY_BUTTON } from './profileCard';

export const PlayerBio = () => {
  const dispatch = useDispatch();
  const { profile, updateLoading } = useSelector((state) => state.playerProfile);
  const [isEditing, setIsEditing] = useState(false);
  const [bio, setBio] = useState('');

  useEffect(() => {
    if (profile?.description) {
      setBio(profile.description);
    }
  }, [profile]);

  return (
    <section className={`${CARD} min-w-0`}>
      <CardTitle title="Bio">
        {!isEditing && <EditButton onClick={() => setIsEditing(true)}>Edit bio</EditButton>}
      </CardTitle>

      {isEditing ? (
        <div>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            rows="5"
            className="w-full px-4 py-3 rounded-xl bg-jp-field border border-jp-line text-jp-ink focus:outline-none focus:ring-2 focus:ring-jp-accent/40 transition-all resize-none"
            maxLength="500"
          />
          <div className="flex items-center justify-between mt-3">
            <span className="text-xs text-jp-muted">{bio.length}/500 characters</span>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => { setIsEditing(false); setBio(profile?.description || ''); }}
                className={SECONDARY_BUTTON}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  dispatch(updatePlayerProfile({ description: bio }));
                  setIsEditing(false);
                }}
                disabled={updateLoading}
                className="px-4 py-2 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-slate-900 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
              >
                {updateLoading && (
                  <div className="w-3 h-3 mr-1.5 border-2 border-jp-line border-t-transparent rounded-full animate-spin"></div>
                )}
                Save
              </button>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-jp-muted text-sm leading-relaxed whitespace-pre-line">
          {bio || <span className="text-jp-muted/80">Tell coaches about yourself. Click "Edit bio" to add one.</span>}
        </p>
      )}
    </section>
  );
};

export default PlayerBio;
